import React from "react";
import "./UserManagementGrid.scss";
import {
  SofturaTable,
  Search,
  PrimaryButton,
  RadioContainer,
  DropdownBox
} from "../../../../../CommonComponents";
import { FilteringMode } from 'ka-table/enums';

interface IProps {
  data?: any;
  setSelectedKey?: any;
  columns: any;
  onExportExcel: () => void;
  searchTextChange: any;
  searchFilterChange: Function;
  searchFilter: string;
  searchedText: string;
  searchClickHandler: () => void;
  clearFilter: () => void;
  serverTotal: number;
  pagesCount: number;
  setFiltersValue: (filters: any) => void;
  fetchAction: (data: any) => void;
  showGrid: boolean
}

const UserManagementGrid = ({
  data,
  columns,
  onExportExcel,
  searchTextChange,
  searchFilterChange,
  searchFilter,
  searchedText,
  searchClickHandler,
  clearFilter,
  serverTotal,
  pagesCount,
  setFiltersValue,
  fetchAction,
  showGrid
}: IProps) => {
  return (
    <div className="app-grid-container user-management">
      <div className="clearfix filter-container">
        <div className="serach-card">
          <div className="card card-1">
            <RadioContainer
              id={"id"}
              options={[
                { key: "user", text: "User" },
                { key: "company", text: "Company", disabled: true },
              ]}
              selectedKey={searchFilter}
              onChange={searchFilterChange}
             data-attribute="UserManagementGrid_Default_Radio" />
            <Search
              placeholder="Search "
              className="searchTextbox"
              value={searchedText}
              onChange={searchTextChange}
              onClear={clearFilter}
             data-attribute="UserManagementGrid_Default_Searchbox" />
          </div>
          <div className="card card-2">
            <RadioContainer
              id={"id"}
              options={[
                { key: "Series", text: "Series", disabled:true },
                { key: "District", text: "District", disabled:true },
                { key: "Division", text: "Division", disabled:true },
              ]}
             data-attribute="UserManagementGrid_Default_Radio_2" />
            <DropdownBox
              disabled={true}
              placeholder="Search"
              className="searchTextbox"
              options={[
                { key: "Series", text: "Series" },
                { key: "District", text: "District" },
                { key: "Division", text: "Division" },
              ]}
             data-attribute="UserManagementGrid_Default_Dropdown" />
          </div>
        </div>
        <div className="filter-btns">
          <PrimaryButton text="Search" className="" onClick={searchClickHandler}  data-attribute="UserManagementGrid_Default_Button" />
          {/* <PrimaryButton
            text="Export Excel"
            className=""
            onClick={onExportExcel}
           data-attribute="UserManagementGrid_Default_Button_2" /> */}
        </div>
      </div>
      <div
        className={
          data?.length !== 0 ? "softura-table" : "softura-table paginationNav"
        }
      >
        {showGrid ?
          <SofturaTable
            data={data ?? []}
            columns={columns}
            sort={true}
            defaultPageSize={10}
            pageSizes={[10, 20, 50]}
            globalSearch={false}
            filter={true}
            getFilterValue={setFiltersValue}
            serverTotal={serverTotal}
            fetchAction={fetchAction}
            isServerSide={true}
            pagesCount={pagesCount}
            defaultPaginationPosition='Both'
            fixedHeader={true}
            filteringMode={FilteringMode.FilterRow}
           data-attribute="UserManagementGrid_Default_Grid" />
          : null
        } 
      </div>
    </div>
  );
};

export default UserManagementGrid;
